var m = require('mithril');
var moment = require('moment');
var animations = require('../../libs/animations');
var alarmState = require('../../alarms/alarmState');
var Point = require('../models/point');
var boolBox = require('../../components/boolBox');
var pointSubscriber = require('../../components/pointSubscriberClass');

var dateFormat = 'dddd MMMM D YYYY, h:mm:ss a';

function hasAlarmEvaluationError(pointRecord) {
  var alarmError = pointRecord && pointRecord.alarmError;
  return alarmError === true || alarmError === 1 || alarmError === '1' || alarmError === 'true';
}

module.exports = {
  oninit: function (vnode) {
    var ctrl = this;
    ctrl.parentCtrl = vnode.attrs.parentCtrl;
    ctrl.column = { in: vnode.attrs.parentCtrl.point() };
  },
  oncreate: function () {
    this.pointSubscriberObj = new pointSubscriber();
    this.pointSubscriberObj.subscribe(this);
  },
  onremove: function () {
    this.pointSubscriberObj.unsubscribe(this);
  },

  onupdate: function (vnode) {
    if(this.column.in['@rid'] != vnode.attrs.parentCtrl.point()['@rid']){
      this.pointSubscriberObj.unsubscribe(this);
      this.column = { in: vnode.attrs.parentCtrl.point() };
      this.pointSubscriberObj.subscribe(this);
      m.redraw();
    }
  },

  view: function () {
    var ctrl = this;
    var displayValue = Point.readValue(ctrl.parentCtrl.point()) || '';

    return m('div', [
      m('div.flex.justify-between.items-center.bb.bw1.pr3-ns', [
        m("p", "Value: "),
        m('div', [
          (()=>{
            if(Point.formatUnit(ctrl.parentCtrl.point()) == 'bool'){
              return m(boolBox, {
                column: this.column,
                pointRecord: ctrl.parentCtrl.point(), 
                clickFunction: ()=>{},
                disableInteractions: true
              }
              );
            }else{
              return m('div',[
                m('span.moon-gray', { 
                  style: { 'text-decoration': Date.now() - ctrl.parentCtrl.point().time > 60000 ? 'line-through' : '',
                  minWidth: displayValue.length + 'ch',
                }},         
                  m('span.ma0', {
                    typewriterString: displayValue, 
                    onupdate: animations.typer
                  }, displayValue)
                ),
                m('span.v-top.dib.moon-gray', {style: {fontSize: '10px'}}, '  ' + Point.formatUnit(ctrl.parentCtrl.point()))
              ])
            }
          })(),
        ])
      ]),
      m('div.flex.justify-between.items-center.bb.bw1.pr3-ns', [
        m("p", "Unformatted Value: "),
        m("p.tl", ctrl.parentCtrl.point().value)
      ]),
      m('div.flex.justify-between.items-center.bb.bw1.pr3-ns', [
        m("p", "Alarm Status: "),
        m("p.tl", [
          ctrl.parentCtrl.point().alarmStatus || 'Clear',
          hasAlarmEvaluationError(ctrl.parentCtrl.point()) ? m('span.ml2.yellow', '⚠️ Error') : null
        ])
      ]),
      m('div.flex.justify-between.items-center.bb.bw1.pr3-ns', [
        m("p", "Last Update: "),
        m("p.tl",  moment(parseInt(ctrl.parentCtrl.point().time)).format(dateFormat) || 'Never')
      ]),
      m('div.flex.justify-between.items-center.bb.bw1.pr3-ns', [
        m("p", "Alarm Tripped Time: "),
        m("p.tl", ctrl.parentCtrl.point().trippedTime || 'Clear')
      ]),
      m('div.flex.justify-between.items-center.bb.bw1.pr3-ns', [
        m("p", "Alarm Reset Time: "),
        m("p.tl", ctrl.parentCtrl.point().resetTime || 'Clear')
      ]),
      m('div.flex.justify-between.items-center.bb.bw1.pr3-ns', [
        m("p", "Communication Error: "),
        m("p.tl", ctrl.parentCtrl.resource().error || 'No Error')
      ]),
      m('div.pv3',  [
        m('div.mr2.dib','Origin: '),
        (Array.isArray(ctrl.parentCtrl.resource().path) ? ctrl.parentCtrl.resource().path : []).map(function (ancestor, idx, arr) {
          if (!ancestor || !ancestor['@id'] || !ancestor.name) { return null; }
          return m('div.mr2.dib.', [
            m('a', {href: '#/' + ancestor['@id'].split('/').slice(3).join('/').toLowerCase()}, ancestor.name),
            (idx < (arr.length - 1) ? ' / ' : '')
          ]);
        })
      ])
    ]);
  }
}
